export default {
    "home": {
        "totalSales": "Total sales",
        "itemsSold": "Items sold",
        "todo": "My active orders",
        "orderName": "Order Name",
        "createdAt": "Created at",
        "downloadLabel": "Download label",
        "last30day": "Last 30 day overview"
    },
    "downloadLabel": "Download",
    "logout": "Log out",
    "homePage": "Home",
    "orders": "Orders",
    "products": "Products",
    "settings": {
        "label": "Settings",
        "error": {
            "name": "Name must be set",
            "emailMissing": "Email must be set",
            "charge": "Charge must be between 0 and 100%",
            "emailValid": "Please enter a valid email",
            "emailTooLong": "The maximum length of an email address is 255 characters",
            "iban": "Please enter a valid IBAN number",
            "textTooLong": "Maximum text length is 1024 characters",
            "phoneNr": "Please enter a valid phone number",
            "validDate": "Please enter a date in format DD.MM.YYYY",
            "partnerMissing": "Please select a Partner"
        },
        "action": {
            "saved": "Settings saved"
        },
        "partnerName": "Partner name",
        "externalName": "Partner external name",
        "email": "Email address",
        "upcharge": "Ehestu mark-up",
        "chargeExpl": {
            "text1": "Retail price is set as",
            "text2": "item cost * vat * (1 + upcharge / 100)",
            "text3": "E.x."
        },
        "chargePerItem": "Markup can be set per item",
        "deliveryTime": {
            "label": "Global delivery time (in days)",
            "min": "Min",
            "max": "Max"
        },
        "additionalEmails": "Additional email addresses",
        "addAdditionalEmail": "Add new email",
        "generalPartnerInfo": "General partner information",
        "partnerDescription": "Partner description",
        "homepage": "Partner homepage",
        "iban": "Partner iban account",
        "logoUrl": "Partner logo url",
        "phoneNr": "Partner phone number",
        "regNr": "Company registration number",
        "vatNr": "Company VAT number",
        "representative": "Company representative",
        "dateJoined": "Partner joining date",
        "isadmin": "Is Admin",
        "integrations": {
            "label": "Integrations"
        }
    },
    "adminSettings": "Admin Settings",
    "adminOrders": "Admin Orders",
    "partnerManagement": "Partner Management",
    "userManagement": "User Management",
    "reviewProductChanges": "Review Product Changes",
    "eventLog": "Event Log",
    "order": {
        "name": "Order name",
        "creationTime": "Created at",
        "status": {
            "label": "Order status",
            "error": "Error",
            "emailSkipped": "Error",
            "emailSent": "Waiting to be po",
            "packageReceived": "Package received",
            "packagePosted": "Package has been posted",
            "cancelled": "Cancelled"
        },
        "item": {
            "name": "Product name",
            "quantity": "Quantity",
            "retailPrice": "Retail price (with VAT)",
            "partnerPrice": "Partner price (without VAT)"
        },
        "generateReport": "Generate report"
    },
    "orderReport": {
        "title": "Print Report",
        "startDate": "Start date",
        "endDate": "End date",
        "print": "Print"
    },
    "product": {
        "name": "Product name",
        "partner": "Partner",
        "save": "Save",
        "action": {
            "inventoryUpdated": "Inventory updated successfully"
        },
        "variant": {
            "available": "Available",
            "trackQuantity": "Track quantity",
            "save": "Save",
            "deliveryTime": {
                "name": "Delivery Time (in business days)"
            }
        },
        "variants": "Variants",
        "inventory": {
            "edit": "Edit inventory",
            "label": "Inventory",
            "disabled": "Please save the product first before updating inventory",
            "notTracked": "Inventory not tracked"
        },
        "noDeliveryDate": "No delivery date",
        "noDeliveryDateDisabled": "Select a partner to filter by missing delivery date"
    },
    "cancel": "Cancel",
    "save": "Save",
    "partner": {
        "name": "Partner name",
        "new": "New partner"
    },
    "admin": {
        "settings": {
            "fulfill": "Automatically fulfill orders in Shopify",
            "reminder": "Send reminder emails every Mon, Wed, Fri",
            "receiveOrders": "Receive new orders from shopify",
            "sendEmails": "Send order emails to partners",
            "label": "Admin Settings",
            "newPartner": "Send a notification email on new partner",
            "deliveryCountries": "Delivery countries",
            "deliveryLt": "Enable delivery to Lithuania",
            "deliveryLv": "Enable delivery to Latvia",
            "deliveryFi": "Enable delivery to Finland",
            "orderChange": "Send a notification email on order change"
        }
    },
    "feedback": {
        "send": {
            "succesful": "Feedback successfully sent",
            "action": "Send"
        },
        "title": "Send feedback",
        "description": "Kindly inform us if you experience any issues with Ehestu Partner or have any recommendations on enhancing the website's usability"
    },
    "card": {
        "close": "Close"
    },
    "login": {
        "title": "Please sign in with your Google account"
    },
    "collections": "Collections",
    "collection": {
        "name": "Collection name",
        "edit": "Edit collection"
    },
    "user": {
        "new": "New user",
        "management": "User Management"
    },
    "integrations": {},
    "partnerOverview": "Partner Orders",
    "partnerOverviewReport": {
        "customRange": "Custom date range",
        "startDate": "Start date",
        "endDate": "End date",
        "printCustomRange": "Print report",
        "error": {
            "endDateBeforeStart": "End date must be the same as or after start date",
            "futureEndDate": "End date cannot be in the future"
        }
    },
    "months": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}
